import axios, {AxiosRequestHeaders, AxiosResponse} from "axios";

export async function sendRequest<D, T>(endPoint: string, method: string, data?: D): Promise<AxiosResponse<T, D>> {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const headers: AxiosRequestHeaders = {
      "Accept": "application/json",
    }

    if (data) {
      headers['Content-Type'] = 'application/json';
    }

    // Get auth token from local storage
    const token = window.localStorage.getItem("jwt");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return await axios({
      method: method,
      url: `${apiUrl}${endPoint}`,
      headers: headers,
      data: data,
    });
  } catch (error) {
    console.error('Error sending request:', error);
    throw error;
  }
}